// Adapted from davinci-elections packages/shared/src/primitives.ts @ 6e23f58
import { z } from 'zod'

/** Reusable scalar schemas. Every API contract is built from these. */

/**
 * A uuid in its canonical (lower-case) form. Postgres matches a uuid in any case but returns it in lower case, so an id
 * taken from a request must be canonical before it is bound into anything compared byte for byte (the AAD of an
 * envelope, an audit target, a job payload).
 */
export const UuidSchema = z.uuid().toLowerCase()

/** ISO 8601 datetime with offset, e.g. `2026-10-04T17:58:34.012Z`. */
export const IsoDateTimeSchema = z.iso.datetime({ offset: true })
export type IsoDateTime = z.infer<typeof IsoDateTimeSchema>

export const EmailSchema = z.string().trim().max(254).pipe(z.email())

export const OkResponseSchema = z.object({ ok: z.literal(true) })
export type OkResponse = z.infer<typeof OkResponseSchema>

/** Provider id (biometric providers and IP sources): lower case, starts with a letter. */
export const ProviderIdSchema = z.string().regex(/^[a-z][a-z0-9_-]{1,31}$/)
export type ProviderId = z.infer<typeof ProviderIdSchema>
